export enum InvoiceState {
  preliminary = 'preliminary',
  draft = 'draft',
  validated = 'validated',
  published = 'published',
  unpublished = 'unpublished',
  credit = 'credit',
  estimationReport = 'estimation-report',
  notfound = 'notfound',
  outsideContract = 'outside-contract',
  multipleContracts = 'multiple-contracts',
  all = 'all',
}
